<template>
  <main class="grid" style="position: relative">
    <v-img
      v-if="$vuetify.breakpoint.mdAndUp"
      @click="handleHomeClick"
      class="cursor-pointer"
      :src="brand.logo"
      contain
      id="logo"
      :width="logoSize.width"
      :height="logoSize.height"
      :alt="$t('brandLogoGoHome')"
      style="position: fixed; top: 12px; left: 12px; z-index: 99"
    ></v-img>

    <v-btn
      v-if="$vuetify.breakpoint.mdAndUp"
      @click="handlePreviousClick"
      fab
      small
      color="brand"
      style="position: fixed; top: 80px; left: 20px; z-index: 99"
      ><v-icon color="white">{{ icons.mdiArrowLeft }}</v-icon></v-btn
    >

    <div
      class="container2"
      :class="[activeContainer === 0 ? 'container2-hide-overflow' : '']"
    >
      <view-selected-project-header
        :project="project"
        :loading="loadingHeader"
        :documentCount="documentCount"
        :memberCount="memberCount"
        :userPermissions="currUserPermissions"
        :updatedKey="updatedKey"
        :maxedOutProjectMembers="maxedOutProjectMembers"
        :isArchived="isArchived"
        @join="joinProjectHandler"
        @invite-member="showInviteMembersDialog = true"
        @logo-clicked="hanldeActiveSection(0)"
        @show-pricing-dialog="showPricingDialogHandler"
      ></view-selected-project-header>

      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-skeleton-loader
          v-if="tabsLoading"
          type="heading"
          class="mt-5"
        ></v-skeleton-loader>

        <div
          v-else
          :style="[
            $vuetify.breakpoint.smAndUp ? tabsFixedStyle : '',
            $vuetify.breakpoint.sm ? { maxWidth: containerMaxWidth } : {}
          ]"
          style="z-index: 99;"
        >
          <v-tabs
            v-model="activeTab"
            @change="onTabChange"
            class="ma-0 pa-0 mt-5"
            light
            slider-color="brand"
            riple
            show-arrows
            style="z-index: 99;"
          >
            <v-tab
              v-for="tab in tabs"
              :key="tab"
              class="cursor-pointer"
              :disabled="isArchived && tab === 'settings'"
            >
              <div>{{ $t(tab) }}</div>
            </v-tab>
          </v-tabs>
          <v-divider></v-divider>
        </div>

        <div class="mt-2" :key="forceUpdate">
          <transition name="slide-fade">
            <keep-alive>
              <view-selected-project-home-section
                v-if="activeTab === 0"
                :description="description"
                :members="latestMembers"
                :showcases="latestShowcases"
                :loading="lastestItemsLoading"
                :projectLogo="projectLogo"
                :projectName="projectName"
                :projectColors="projectColors"
                :currUserPermissions="currUserPermissions"
                :userIsProjectLeader="userIsProjectLeader"
                :maxedOutProjectMembers="maxedOutProjectMembers"
                :hasParentProject="hasParentProject"
                :parentProject="parentProject"
                @get-members-and-showcases="getLatestMembersAndShowcases"
                @open-invite-dialog="showInviteMembersDialog = true"
                @on-tab-change="routeToSection"
                @view-latest-item="viewLatestItem"
                @show-pricing-dialog="showPricingDialogHandler"
              ></view-selected-project-home-section>

              <view-selected-project-guideline-section
                v-if="$route.query.section === 'guidelines'"
                :guidelines="projectGuidelines"
              ></view-selected-project-guideline-section>

              <view-selected-project-member-section
                v-if="$route.query.section === 'members'"
                @get-members="getMembers"
                @add-filter="
                  value => {
                    handleFilter(value, 'memberFilters'), getMembers();
                  }
                "
                @remove-filter="
                  value => {
                    removeFilter(value, 'memberFilters'), getMembers();
                  }
                "
                @remove-additional-filters="removeFilter('all-additonal')"
                @member-deleted="memberDeletion"
                @reassignment-from-group="reassignmentFromGroupHandler"
                @rehydrate-group-leader="rehydrateGLHandler"
                @load-more="getMoreMembers"
                @open-invite-dialog="showInviteMembersDialog = true"
                @show-pricing-dialog="showPricingDialogHandler"
                @handle-sort="
                  value => {
                    (memberSort = value), getMembers();
                  }
                "
                @created-member-section="
                  getMemberOfNames($route.params.id, memberFilters)
                "
                @get-member-of-names="getMemberOfNamesForDialog"
                :members="members"
                :canLoadMore="canLoadMoreMembers"
                :loading="membersLoading"
                :currUserPermissions="currUserPermissions"
                :project="project"
                :projectRoles="projectRoles"
                :permissions="permissions"
                :defaultRoles="defaultRoles"
                :filters="memberFilters"
                :userIsProjectLeader="userIsProjectLeader"
                :defaultLanguage="defaultLanguage"
                :userIsGroupLeader="userIsGroupLeader"
                :maxedOutProjectMembers="maxedOutProjectMembers"
                :sort="memberSort"
                :projectMemberOfNames="projectMemberOfNames"
                :colors="colors"
                :tagsUnfiltered="tagsUnfiltered"
                :isArchived="isArchived"
              ></view-selected-project-member-section>

              <view-selected-project-showcase-section
                v-if="$route.query.section === 'showcases'"
                @get-showcases="getShowcases"
                @add-filter="
                  value => {
                    handleFilter(value, 'showcaseFilters'), getShowcases();
                  }
                "
                @remove-filter="
                  value => {
                    removeFilter(value, 'showcaseFilters'), getShowcases();
                  }
                "
                @handle-sort="
                  value => {
                    (showcaseSort = value), getShowcases();
                  }
                "
                @load-more="getMoreShowcases"
                @created-showcase-section="
                  getSectionAdditionalFilters('document')
                "
                :showcases="showcases"
                :canLoadMore="canLoadMoreShowcases"
                :loading="showcasesLoading"
                :project="project.project"
                :userIsProjectMember="userIsProjectMember"
                :userIsProjectLeader="userIsProjectLeader"
                :filters="showcaseFilters"
                :sort="showcaseSort"
                :kindList="kindList"
                :kindsUnfiltered="kindsUnfiltered"
                :statusList="statusCountList.document"
                :canArchiveContent="canArchiveContent"
                :colors="colors"
              ></view-selected-project-showcase-section>

              <view-selected-project-creativity-section
                v-if="$route.query.section === 'creativities'"
                @get-showcases="getCreativities"
                @add-filter="
                  value => {
                    handleFilter(value, 'creativityFilters'), getCreativities();
                  }
                "
                @remove-filter="
                  value => {
                    removeFilter(value, 'creativityFilters'), getCreativities();
                  }
                "
                @load-more="getMoreCreativites"
                @handle-sort="
                  value => {
                    (creativitySort = value), getCreativities();
                  }
                "
                @created-creativities-section="
                  getSectionAdditionalFilters('creativity')
                "
                :showcases="creativities"
                :canLoadMore="canLoadMoreCreativities"
                :loading="creativityLoading"
                :project="project.project"
                :userIsProjectMember="userIsProjectMember"
                :userIsProjectLeader="userIsProjectLeader"
                :filters="creativityFilters"
                :sort="creativitySort"
                :kindList="kindList"
                :kindsUnfiltered="kindsUnfiltered"
                :statusList="statusCountList.creativity"
                :canArchiveContent="canArchiveContent"
                :colors="colors"
              ></view-selected-project-creativity-section>

              <view-selected-project-group-section
                v-if="$route.query.section === 'groups'"
                @load-more="getMoreGroups"
                @get-groups="getGroups"
                @add-filter="
                  value => {
                    handleFilter(value, 'groupsFilters'), getGroups();
                  }
                "
                @remove-filter="
                  value => {
                    removeFilter(value, 'groupsFilters'), getGroups();
                  }
                "
                @show-pricing-dialog="showPricingDialogHandler"
                @cloud-storage-error="cloudStorageError = true"
                @handle-sort="
                  value => {
                    (groupsSort = value), getGroups();
                  }
                "
                :projectGroups="projectGroups"
                :canLoadMore="canLoadMoreGroups"
                :loading="groupsLoading"
                :currUserPermissions="currUserPermissions"
                :project="project"
                :projectRoles="projectRoles"
                :filters="groupsFilters"
                :maxedOutProjectMembers="maxedOutProjectMembers"
                :sort="groupsSort"
                :isArchived="isArchived"
              ></view-selected-project-group-section>

              <view-selected-project-itinerary-section
                v-if="$route.query.section === 'itineraries'"
                @load-more="getMoreItineraries"
                @get-itineraries="getItineraries"
                @add-filter="
                  value => {
                    handleFilter(value, 'itineraryFilters'), getItineraries();
                  }
                "
                @remove-filter="
                  value => {
                    removeFilter(value, 'itineraryFilters'), getItineraries();
                  }
                "
                @pinHandler="
                  payload => {
                    bookmarkItineraryHandler(payload);
                  }
                "
                @delete="
                  itineraryId => {
                    deleteItinerary(itineraryId);
                  }
                "
                @handle-sort="
                  value => {
                    (itinerarySort = value), getItineraries();
                  }
                "
                @created-itinerary-section="getItineraryAdditionalFilters()"
                @update-status="
                  value => {
                    updateItineraryStatus(value);
                  }
                "
                :canLoadMore="canLoadMoreItineraries"
                :loading="itinerariesLoading"
                :itineraries="itineraries"
                :filters="itineraryFilters"
                :sort="itinerarySort"
                :itinerariesStatusList="itinerariesStatusList"
                :canArchiveContent="canArchiveContent"
                :userIsProjectMember="userIsProjectMember"
                :projectFounderProfileId="projectFounderProfileId"
              ></view-selected-project-itinerary-section>

              <!-- Here we need to pass the Full project to get the new structure with Template property in it -->
              <view-selected-project-settings-section
                v-if="$route.query.section === 'settings' && !loadingHeader"
                :project="fullProject"
                :currUserPermissions="currUserPermissions"
                :memberCount="memberCount"
                :statusList="statusCountList.document"
                @project-update="projectUpdated"
                @fetch-project="fetchProject"
                @refetch-project-roles="fetchProjectRoles"
                @cloud-storage-error="cloudStorageError = true"
                @get-members="getMembers()"
              ></view-selected-project-settings-section>
            </keep-alive>
          </transition>
        </div>
      </template>

      <!-- MOBILE XS SCREENS__________________MOBILE XS SCREENS______________________MOBILE XS SCREENS -->
      <template v-else>
        <div v-for="(tab, index) in tabs" :key="tab">
          <div
            @click="hanldeActiveSection(index)"
            class="d-flex justify-space-between"
            :class="[activeTab === index ? 'xs-tab-active' : 'xs-tab']"
          >
            <span
              :class="[activeTab === index ? 'brand--text' : 'primary--text']"
              style="font-weight: 500"
              >{{ $t(tab) }}</span
            >
            <v-icon :color="activeTab === index ? 'brand' : 'primary'">{{
              activeTab === index ? icons.mdiChevronUp : icons.mdiChevronDown
            }}</v-icon>
          </div>

          <v-expand-transition :appear="false">
            <div v-if="activeTab === index" class="my-4">
              <keep-alive>
                <view-selected-project-home-section
                  v-if="activeTab === 0"
                  :description="description"
                  :members="latestMembers"
                  :showcases="latestShowcases"
                  :loading="lastestItemsLoading"
                  :projectLogo="projectLogo"
                  :projectName="projectName"
                  :projectColors="projectColors"
                  :currUserPermissions="currUserPermissions"
                  :userIsProjectLeader="userIsProjectLeader"
                  :maxedOutProjectMembers="maxedOutProjectMembers"
                  :hasParentProject="hasParentProject"
                  :parentProject="parentProject"
                  @get-members-and-showcases="getLatestMembersAndShowcases"
                  @open-invite-dialog="showInviteMembersDialog = true"
                  @on-tab-change="routeToSection"
                  @view-latest-item="viewLatestItem"
                  @show-pricing-dialog="showPricingDialogHandler"
                ></view-selected-project-home-section>

                <view-selected-project-guideline-section
                  v-if="$route.query.section === 'guidelines'"
                  :guidelines="projectGuidelines"
                ></view-selected-project-guideline-section>

                <view-selected-project-member-section
                  v-if="$route.query.section === 'members'"
                  @get-members="getMembers"
                  @add-filter="
                    value => {
                      handleFilter(value, 'memberFilters'), getMembers();
                    }
                  "
                  @remove-filter="
                    value => {
                      removeFilter(value, 'memberFilters'), getMembers();
                    }
                  "
                  @remove-additional-filters="
                    removeFilter('all-additonal', 'memberFilters'), getMembers()
                  "
                  @member-deleted="memberDeletion"
                  @reassignment-from-group="reassignmentFromGroupHandler"
                  @rehydrate-group-leader="rehydrateGLHandler"
                  @load-more="getMoreMembers"
                  @open-invite-dialog="showInviteMembersDialog = true"
                  @show-pricing-dialog="showPricingDialogHandler"
                  @handle-sort="
                    value => {
                      (memberSort = value), getMembers();
                    }
                  "
                  @created-member-section="
                    getMemberOfNames($route.params.id, memberFilters)
                  "
                  @get-member-of-names="getMemberOfNamesForDialog"
                  :members="members"
                  :canLoadMore="canLoadMoreMembers"
                  :loading="membersLoading"
                  :currUserPermissions="currUserPermissions"
                  :project="project"
                  :projectRoles="projectRoles"
                  :permissions="permissions"
                  :defaultRoles="defaultRoles"
                  :filters="memberFilters"
                  :userIsProjectLeader="userIsProjectLeader"
                  :defaultLanguage="defaultLanguage"
                  :userIsGroupLeader="userIsGroupLeader"
                  :maxedOutProjectMembers="maxedOutProjectMembers"
                  :sort="memberSort"
                  :projectMemberOfNames="projectMemberOfNames"
                  :colors="colors"
                  :tagsUnfiltered="tagsUnfiltered"
                  :isArchived="isArchived"
                ></view-selected-project-member-section>

                <view-selected-project-showcase-section
                  v-if="$route.query.section === 'showcases'"
                  @get-showcases="getShowcases"
                  @add-filter="
                    value => {
                      handleFilter(value, 'showcaseFilters'), getShowcases();
                    }
                  "
                  @remove-filter="
                    value => {
                      removeFilter(value, 'showcaseFilters'), getShowcases();
                    }
                  "
                  @load-more="getMoreShowcases"
                  @handle-sort="
                    value => {
                      (showcaseSort = value), getShowcases();
                    }
                  "
                  @created-showcase-section="
                    getSectionAdditionalFilters('document')
                  "
                  :showcases="showcases"
                  :canLoadMore="canLoadMoreShowcases"
                  :loading="showcasesLoading"
                  :project="project.project"
                  :userIsProjectMember="userIsProjectMember"
                  :userIsProjectLeader="userIsProjectLeader"
                  :filters="showcaseFilters"
                  :sort="showcaseSort"
                  :kindList="kindList"
                  :kindsUnfiltered="kindsUnfiltered"
                  :statusList="statusCountList.document"
                  :canArchiveContent="canArchiveContent"
                  :colors="colors"
                ></view-selected-project-showcase-section>

                <view-selected-project-creativity-section
                  v-if="$route.query.section === 'creativities'"
                  @get-showcases="getCreativities"
                  @add-filter="
                    value => {
                      handleFilter(value, 'creativityFilters'),
                        getCreativities();
                    }
                  "
                  @remove-filter="
                    value => {
                      removeFilter(value, 'creativityFilters'),
                        getCreativities();
                    }
                  "
                  @load-more="getMoreCreativites"
                  @handle-sort="
                    value => {
                      (creativitySort = value), getCreativities();
                    }
                  "
                  @created-creativities-section="
                    getSectionAdditionalFilters('creativity')
                  "
                  :showcases="creativities"
                  :canLoadMore="canLoadMoreCreativities"
                  :loading="creativityLoading"
                  :project="project.project"
                  :userIsProjectMember="userIsProjectMember"
                  :userIsProjectLeader="userIsProjectLeader"
                  :filters="creativityFilters"
                  :sort="creativitySort"
                  :kindList="kindList"
                  :kindsUnfiltered="kindsUnfiltered"
                  :statusList="statusCountList.creativity"
                  :canArchiveContent="canArchiveContent"
                  :colors="colors"
                ></view-selected-project-creativity-section>

                <view-selected-project-group-section
                  v-if="$route.query.section === 'groups'"
                  @load-more="getMoreGroups"
                  @get-groups="getGroups"
                  @add-filter="
                    value => {
                      handleFilter(value, 'groupsFilters'), getGroups();
                    }
                  "
                  @remove-filter="
                    value => {
                      removeFilter(value, 'groupsFilters'), getGroups();
                    }
                  "
                  @show-pricing-dialog="showPricingDialogHandler"
                  @cloud-storage-error="cloudStorageError = true"
                  @handle-sort="
                    value => {
                      (groupsSort = value), getGroups();
                    }
                  "
                  :projectGroups="projectGroups"
                  :canLoadMore="canLoadMoreGroups"
                  :loading="groupsLoading"
                  :currUserPermissions="currUserPermissions"
                  :project="project"
                  :projectRoles="projectRoles"
                  :filters="groupsFilters"
                  :maxedOutProjectMembers="maxedOutProjectMembers"
                  :sort="groupsSort"
                  :isArchived="isArchived"
                ></view-selected-project-group-section>

                <view-selected-project-itinerary-section
                  v-if="$route.query.section === 'itineraries'"
                  @load-more="getMoreItineraries"
                  @get-itineraries="getItineraries"
                  @add-filter="
                    value => {
                      handleFilter(value, 'itineraryFilters'), getItineraries();
                    }
                  "
                  @remove-filter="
                    value => {
                      removeFilter(value, 'itineraryFilters'), getItineraries();
                    }
                  "
                  @pinHandler="
                    payload => {
                      bookmarkItineraryHandler(payload);
                    }
                  "
                  @handle-sort="
                    value => {
                      (itinerarySort = value), getItineraries();
                    }
                  "
                  @created-itinerary-section="getItineraryAdditionalFilters()"
                  @update-status="
                    value => {
                      updateItineraryStatus(value);
                    }
                  "
                  :canLoadMore="canLoadMoreItineraries"
                  :loading="itinerariesLoading"
                  :itineraries="itineraries"
                  :filters="itineraryFilters"
                  :sort="itinerarySort"
                  :canArchiveContent="canArchiveContent"
                  :userIsProjectMember="userIsProjectMember"
                  :projectFounderProfileId="projectFounderProfileId"
                ></view-selected-project-itinerary-section>

                <!-- Here we need to pass the Full project to get the new structure with Template property in it -->
                <view-selected-project-settings-section
                  v-if="$route.query.section === 'settings' && !loadingHeader"
                  :project="fullProject"
                  :currUserPermissions="currUserPermissions"
                  :memberCount="memberCount"
                  :statusList="statusCountList.document"
                  @project-update="projectUpdated"
                  @fetch-project="fetchProject"
                  @refetch-project-roles="fetchProjectRoles"
                  @cloud-storage-error="cloudStorageError = true"
                  @get-members="getMembers()"
                ></view-selected-project-settings-section>
              </keep-alive>
            </div>
          </v-expand-transition>
        </div>
      </template>
      <!-- MOBILE XS SCREENS__________________END______________________MOBILE XS SCREENS -->
    </div>

    <invite-dialog
      v-if="
        currUserPermissions.includes('PROJECT_GROUP_INVITE') &&
          showInviteMembersDialog
      "
      :show="showInviteMembersDialog"
      :project="project.project"
      :groupIfViewingGroup="project.projectGroup"
      :groupsUserCanInvite="profileGroupsForInvite"
      :projectRolesFromParent="projectRoles"
      :defaultProjectGroupId="defaultProjectGroupId"
      :profileDefaultGroup="profileDefaultGroup"
      :currUserPermissions="currUserPermissions"
      :key="inviteDialogKey"
      @close="(showInviteMembersDialog = false), inviteDialogKey++"
      @invited-user="checkProjectMembersSubscriptionMax"
    >
    </invite-dialog>

    <!-- REGISTRATIONS Process-->
    <!-- Show Dialog after joining from project not from direct registration -->
    <base-message-dialog
      v-if="showJoinedProjectDialog"
      :show="showJoinedProjectDialog"
    >
      <template v-slot:card-image>
        <timeline :brand="brand" width="200px"></timeline>
      </template>

      <template v-slot:title>
        <h3 class="mt-2">{{ $t('successJoiningProject') }}</h3>
      </template>

      <template v-slot:message>
        <p class="mt-2">
          {{ $t('successJoiningProjectMsg') }}
        </p>
      </template>

      <template v-slot:card-action>
        <v-btn
          @click="continueJoinedEnrollment"
          color="brand"
          class="white--text"
          >{{ $t('continue') }}</v-btn
        >
      </template>
    </base-message-dialog>
    <v-dialog
      v-if="showEmailCard"
      :value="showEmailCard"
      scrollable
      :max-width="dialogWidth"
    >
      <check-email-card
        :brand="brand"
        :projectSelfResgitering="true"
        :project="project"
        :dialogMode="true"
      ></check-email-card>
    </v-dialog>

    <!-- Show dialog after self registering and only selecting other role -->
    <base-message-dialog
      v-if="showBaseMsgDialogEnrollmentOtherRole"
      :show="showBaseMsgDialogEnrollmentOtherRole"
    >
      <template v-slot:card-image>
        <timeline :brand="brand" width="200px"></timeline>
      </template>

      <template v-slot:title>
        <h3 class="mt-2">{{ $t('successfullyRegistered') }}</h3>
      </template>

      <template v-slot:message>
        <p v-if="onlyOtherRole" class="mt-2">
          {{ $t('successRegistration') }}
          {{ project.project.name }}.
          {{ $t('successfullyRegisteredMsg') }}
        </p>

        <p v-else>
          {{ $t('successRegistration') }}
          {{ project.project.name }}.
        </p>
      </template>

      <template v-slot:card-action>
        <v-btn @click="showBaseMsgDialogEnrollmentOtherRole = false" text>{{
          $t('understood')
        }}</v-btn>
      </template>
    </base-message-dialog>

    <view-selected-project-direct-registration-dialog
      v-if="showDirectRegistrationDialog"
      :show="showDirectRegistrationDialog"
      :directRegistrationRoles="directRegistrationRoles"
      :project="project.project"
      :loading="loadingDirectRegistration"
      :brand="brand"
      @continueEnrollment="continueDirectRegistrationEnrollment"
    ></view-selected-project-direct-registration-dialog>
    <!-- REGISTRATION Process -->

    <!-- Deleteion Process -->
    <delete-member-dialog
      v-if="showDeleteDialog && memberMarkedForDeletion"
      :show="showDeleteDialog"
      :member="memberMarkedForDeletion"
      :project="project"
      :deleteLoading="deleteLoading"
      @close="showDeleteDialog = false"
      @deleteMember="deleteMemberHandler"
    ></delete-member-dialog>
    <!-- Show if Delete member with pusblished showcase -->
    <base-message-dialog
      v-if="showDeletingMemberWithPublishedShowcase"
      :show="showDeletingMemberWithPublishedShowcase"
    >
      <template v-slot:card-image>
        <more-steps :brand="brand" width="200px"></more-steps>
      </template>

      <template v-slot:title>
        <h3 class="mt-2">{{ $t('unableToDeleteMember') }}</h3>
      </template>

      <template v-slot:message>
        <p class="mt-2">
          {{ $t('deletingMemberWithPDocsMsg') }}
        </p>
      </template>

      <template v-slot:card-action>
        <v-btn
          @click="showDeletingMemberWithPublishedShowcase = false"
          text
          class="mr-2"
          >{{ $t('cancel') }}</v-btn
        >

        <v-btn
          @click="unpulishAndDeleteHandler"
          color="brand"
          class="white--text"
          :loading="unpublishLoading"
          >{{ $t('yes') }}</v-btn
        >
      </template>
    </base-message-dialog>
    <!-- Deleteion Process -->

    <pricing-dialog
      v-if="showPricingDialog"
      @close="
        (showPricingDialog = false),
          pricingDialogKey++,
          (showInviteMessagePricingDialog = false)
      "
      :key="`price-dialog-${pricingDialogKey}`"
      :show="showPricingDialog"
      :projectSubscriptionInfo="projectSubscriptionInfo"
      :originatedOnInvite="showInviteMessagePricingDialog"
    ></pricing-dialog>

    <base-reached-max-dialog
      v-if="showReachedMax"
      :show="showReachedMax"
      :reachedMaxInformation="reachedMaxInformation"
      :key="maxDialogKey"
      @close="closeBaseReachedMaxHandler"
    ></base-reached-max-dialog>

    <!-- Dialog to display cloud storage error-->
    <base-message-dialog v-if="cloudStorageError" :show="cloudStorageError">
      <template v-slot:card-image>
        <warning width="200px" :brand="brand"></warning>
      </template>

      <template v-slot:title
        ><h3 class="mb-2">{{ $t('outOfCloudStorageSpace') }}</h3></template
      >

      <template v-slot:message>
        <p>
          {{ $t('youRanOutOfCloudStorage') }}
        </p>
      </template>

      <template v-slot:card-action>
        <v-row no-gutters class="px-3" justify="end">
          <v-btn to="/" elevation="0" text small class="mr-2">{{
            $t('goToDashboard')
          }}</v-btn>

          <v-btn
            to="/subscriptions"
            elevation="0"
            small
            color="brand"
            class="white--text"
            >{{ $t('upgrade') }}</v-btn
          >
        </v-row>
      </template>
    </base-message-dialog>
  </main>
</template>

<script>
import Swal from 'sweetalert2';
import { mapState, mapActions } from 'vuex';
import { mdiChevronDown, mdiChevronUp, mdiArrowLeft } from '@mdi/js';
import {
  projects as projectAPI,
  profiles as profileAPI,
  permissions as permissionAPI,
  membersOf as memberOfAPI,
  documents as documentAPI,
  projectGroups as projectGroupAPI,
  roles as rolesApi,
  itineraries as itinerariesAPI
} from '@/utilities/api';
import { TemplateArrayHelpers } from '@/utilities/mixins/TemplateArrayHelpers';
import { LanguageHelpers } from '@/utilities/mixins/LanguageHelpers';
import { FiltersMixin } from '@/utilities/mixins/FiltersMixin';

import ViewSelectedProjectHeader from './ViewSelectedProjectHeader';
const ViewSelectedProjectHomeSection = () =>
  import('./ViewSelectedProjectHomeSection');
const ViewSelectedProjectGuidelineSection = () =>
  import('./ViewSelectedProjectGuidelineSection');
const ViewSelectedProjectGroupSection = () =>
  import('./ViewSelectedProjectGroupSection');
const ViewSelectedProjectShowcaseSection = () =>
  import('./ViewSelectedProjectShowcaseSection');
const ViewSelectedProjectCreativitySection = () =>
  import('./ViewSelectedProjectCreativitySection');
const ViewSelectedProjectMemberSection = () =>
  import('./ViewSelectedProjectMemberSection');
const ViewSelectedProjectItinerarySection = () =>
  import('./ViewSelectedProjectItinerarySection');
const ViewSelectedProjectSettingsSection = () =>
  import(
    './ViewSelectedProjectSettingsSection/ViewSelectedProjectSettingsSection'
  );
const BaseMessageDialog = () =>
  import(
    '@/components/base_components/BaseMessageDialog/BaseMessageDialog.vue'
  );
const ViewSelectedProjectDirectRegistrationDialog = () =>
  import('./ViewSelectedProjectDirectRegistrationDialog.vue');
const DeleteMemberDialog = () => import('./DeleteMemberDialog.vue');
const CheckEmailCard = () => import('@/components/CheckEmailCard.vue');
const InviteDialog = () => import('@/components/InviteDialog.vue');
const Timeline = () => import('../../assets/SvgComponents/Timeline.vue');
const PricingDialog = () =>
  import('@/components/base_components/PricingDialog/PricingDialog.vue');
const BaseReachedMaxDialog = () =>
  import(
    '@/components/base_components/BaseReachedMaxDialog/BaseReachedMaxDialog'
  );
const Warning = () => import('@/assets/SvgComponents/Warning.vue');

export default {
  name: 'ViewSelectedProject',

  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },

  components: {
    ViewSelectedProjectHeader,
    ViewSelectedProjectHomeSection,
    ViewSelectedProjectGuidelineSection,
    ViewSelectedProjectGroupSection,
    ViewSelectedProjectShowcaseSection,
    ViewSelectedProjectCreativitySection,
    ViewSelectedProjectMemberSection,
    ViewSelectedProjectItinerarySection,
    ViewSelectedProjectSettingsSection,
    InviteDialog,
    CheckEmailCard,
    BaseMessageDialog,
    ViewSelectedProjectDirectRegistrationDialog,
    DeleteMemberDialog,
    Timeline,
    PricingDialog,
    BaseReachedMaxDialog,
    Warning
  },

  data: () => ({
    previousRoute: null,
    forceUpdate: 0,
    showInviteMembersDialog: false,
    tabsLoading: true,
    inviteDialogKey: 0,
    loadingHeader: true,
    //This project instance is a copy direclty from the DB with correct structure
    fullProject: {},
    // project: {},
    activeTab: null,
    tabs: [],
    latestShowcases: [],
    latestMembers: [],
    members: [],
    showcases: [],
    memberFilters: [],
    projectGroups: [],
    canLoadMoreMembers: true,
    membersLoading: true,
    memberPayload: {
      page: 1,
      pageSize: 6
    },
    memberSort: {
      sort: 'memberOf.creationDate',
      order: 'desc'
    },
    canLoadMoreShowcases: true,
    showcasesLoading: true,
    showcaseFilters: [],
    showcasePayload: {
      page: 1,
      pageSize: 6
    },
    showcaseSort: {
      sort: 'document.lastUpdate',
      order: 'desc'
    },
    creativities: [],
    canLoadMoreCreativities: true,
    creativityLoading: true,
    creativityFilters: [],
    creativityPayload: {
      page: 1,
      pageSize: 6
    },
    creativitySort: {
      sort: 'document.lastUpdate',
      order: 'desc'
    },
    groupsLoading: true,
    canLoadMoreGroups: true,
    groupsFilters: [],
    groupsPayload: {
      page: 1,
      pageSize: 6
    },
    groupsSort: {
      sort: `projectGroup.name.replace('"', '').replace("'", "")`,
      order: 'asc'
    },
    lastestItemsLoading: true,
    itineraries: [],
    itineraryPayload: {
      page: 1,
      pageSize: 6
    },
    itinerarySort: {
      sort: 'itinerary.lastUpdate',
      order: 'desc'
    },
    itinerariesStatusList: [],
    canLoadMoreItineraries: true,
    itinerariesLoading: true,
    itineraryFilters: [],
    documentCount: 0,
    memberCount: 0,
    currUserPermissions: [],
    projectRoles: [],
    permissions: [],
    showJoinedProjectDialog: false,
    showEmailCard: false,
    showDirectRegistrationDialog: false,
    userStatus: '',
    loadingDirectRegistration: false,
    showBaseMsgDialogEnrollmentOtherRole: false,
    showDeleteDialog: false,
    showDeletingMemberWithPublishedShowcase: false,
    memberMarkedForDeletion: null,
    memberMarkedForDeletionDocuments: [],
    memberMarkedForDeletionMemberIds: [],
    deleteLoading: false,
    unpublishLoading: false,
    profileGroupsForInvite: [],
    defaultProjectGroupId: '',
    profileDefaultGroup: {},
    userIsProjectMember: false,
    defaultRoles: [],
    userIsProjectLeader: false,
    activeContainer: 0,
    userIsGroupLeader: false,
    onlyOtherRole: true,
    updatedKey: 0,
    showPricingDialog: false,
    showReachedMax: false,
    reachedMaxInformation: {},
    maxDialogKey: 0,
    projectMemberCount: null,
    cloudStorageError: false,
    showInviteMessagePricingDialog: false,
    pricingDialogKey: 0,
    kindsUnfiltered: [],
    tagsUnfiltered: [],
    metaTitle: 'Trust Project',
    metaDescription: 'Trust Project description'
  }),

  async created() {
    const urlLang = this.$route?.params?.lang;
    if (urlLang) {
      await this.setUrlLanguage(urlLang);
    }

    this.init();
    this.fetchProjectRoles();
    this.fetchPermissions();
    this.fetchUnfilteredKinds();
    this.fetchUnfilteredTags();
    const hasEnrollment = this.userProfile?.profile?.enrollment;

    if (this.$route?.query?.directRegistration && hasEnrollment) {
      this.showDirectRegistrationDialog = true;
    }

    if (this.$route?.query?.createdProject) {
      this.checkProjectSubscriptionMax();
    }
  },

  mixins: [TemplateArrayHelpers, LanguageHelpers, FiltersMixin],

  methods: {
    ...mapActions(['selfRegistrationExsistingUser', 'getUserProfile']),
    async init() {
      this.loadingHeader = true;
      await this.fetchProject();
      this.metaTitle = this.projectName;
      this.metaDescription = `${this.projectName} ${this.$t(
        'project'
      ).toLowerCase()} ${this.$t('wasCreatedFor')} ${
        this.brand.name
      }. ${this.$t('learnMoreAboutThisProjectByVisting')} ${this.brand.name}`;

      await this.fetchCounts();
      await this.getUserPermissions();
      this.loadingHeader = false;
      this.getTabs();
      this.getDefaultRoles();
    },

    projectUpdated(updatedProject) {
      this.updatedKey++;
      if (this.$route.params.groupId) {
        this.fullProject.projectGroup = updatedProject;
      } else {
        if (!this.hasLabelsFeature) {
          this.fullProject.project = updatedProject;
        } else {
          //need to reset labels to object form
          const { labels, ...theRest } = this.fullproject.project;
          const project = updatedProject;
          project.labels = labels;
          this.fullProject.project = project;
        }
      }
    },

    async fetchCounts() {
      let documentCount = 0;
      let memberCount = 0;
      if (this.$route.params.groupId) {
        memberCount = await projectGroupAPI.getMemberCount(
          this.$route.params.groupId
        );
        documentCount = await projectGroupAPI.getDocumentCount(
          this.$route.params.groupId
        );
      } else {
        documentCount = await projectAPI.getDocumentCount(
          this.$route.params.id
        );
        memberCount = await projectAPI.getMemberCount(this.$route.params.id);
      }
      this.documentCount = documentCount.count;
      this.memberCount = memberCount.count;
    },

    memberDeletion(member) {
      this.memberMarkedForDeletion = member;
      this.showDeleteDialog = true;
    },

    async deleteMemberHandler(memberOfs) {
      try {
        this.deleteLoading = true;
        const { profileId } = memberOfs;
        const projectId = this.$route.params.id;
        const profileDocuments = await profileAPI.getDocuments(profileId, {
          projectId
        });
        const projectGroupIds = memberOfs.deleteMemberOfInfo.map(
          ({ projectGroupId }) => projectGroupId
        );

        const createdAndRejectedDocuments = profileDocuments.list.filter(
          ({ document, projectGroup }) =>
            document.status === 'CREATED' &&
            document.status === 'REJECTED' &&
            projectGroupIds.includes(
              projectGroup.projectGroupId.replace('#', '')
            )
        );

        const nonCreatedOrRejected = profileDocuments.list.filter(
          ({ document, projectGroup }) =>
            document.status !== 'CREATED' &&
            document.status !== 'REJECTED' &&
            projectGroupIds.includes(
              projectGroup.projectGroupId.replace('#', '')
            )
        );

        this.memberMarkedForDeletionMemberIds = memberOfs.deleteMemberOfInfo.map(
          ({ memberOfId }) => memberOfId
        );

        this.memberMarkedForDeletionDocuments = createdAndRejectedDocuments;
        if (nonCreatedOrRejected.length > 0) {
          this.memberMarkedForDeletionDocuments.push(...nonCreatedOrRejected);
          this.showDeletingMemberWithPublishedShowcase = true;
          this.projectMemberCount--;
          this.deleteLoading = false;
          return;
        }
        await this.unpulishAndDeleteHandler();
        this.projectMemberCount--;
        this.deleteLoading = false;
      } catch (e) {
        this.deleteMemberErrorPopup();
        this.deleteLoading = false;
      }
    },

    async unpulishAndDeleteHandler() {
      try {
        this.unpublishLoading = true;
        const documentIdsToBeDeleted = this.memberMarkedForDeletionDocuments.map(
          ({ document }) => document.documentId.replace('#', '')
        );

        const nonCreatedAndRejectedDocuments = this.memberMarkedForDeletionDocuments.filter(
          ({ document }) =>
            document.status !== 'CREATED' && document.status !== 'REJECTED'
        );

        // Change statuses to rejected
        for (const document of nonCreatedAndRejectedDocuments) {
          const id = document.document.documentId.replace('#', '');
          await documentAPI.updateStatus(id, {
            status: 'REJECTED',
            cause: this.$t('reasonForRejectingDoc')
          });
        }

        // Delete documents
        for (const id of documentIdsToBeDeleted) {
          await documentAPI.delete(id);
        }

        // delete the member in the project/project-group
        for (const id of this.memberMarkedForDeletionMemberIds) {
          await memberOfAPI.deleteFromProject(id);
        }
        this.members = this.members.filter(
          ({ profile }) =>
            profile.profileId !== this.memberMarkedForDeletion.profile.profileId
        );

        this.memberMarkedForDeletionMemberIds = [];
        this.memberMarkedForDeletionDocuments = [];
        this.memberMarkedForDeletion = null;
        this.showDeletingMemberWithPublishedShowcase = false;
        this.unpublishLoading = false;
        this.deleteMemberSuccessPopup();
      } catch (e) {
        this.deleteMemberErrorPopup();
        this.unpublishLoading = false;
      }
    },

    joinProjectHandler() {
      const profileId = this.userProfile?.profile?.profileId;
      if (profileId) {
        const payload = {
          profileId: profileId.replace('#', ''),
          projectId: this.$route.params.id
        };

        if (this.$route?.params?.groupId)
          payload.projectGroupId = this.$route.params.groupId;

        this.selfRegisteringUserHandler(
          payload,
          'selfRegistrationExsistingUser'
        );
        return;
      } else {
        this.$router.push(`/direct-registration/${this.$route.params.id}`);
      }
    },

    async selfRegisteringUserHandler(payload, action) {
      const res = await this[action](payload);

      if (res.status === 200) {
        if (this.userProfile?.profile?.profileId) {
          //if logged in
          if (this.userProfile?.profile?.profileId) {
            await this.getUserProfile();
            this.showJoinedProjectDialog = true;
            //if not logged in
          } else {
            Swal.fire({
              title: this.$t('success'),
              text: `${this.$t('successRegistration')} ${
                this.project.project.name
              }`,
              type: 'success',
              confirmButtonColor: `${this.brand.colors.brand}`,
              confirmButtonText: this.$t('close')
            });
            this.$router.push('/login');
          }
        }

        if (!this.userProfile?.profile && this.userStatus === 'unregistered') {
          this.showEmailCard = true;
        }
      } else {
        Swal.fire({
          title: this.$t('error'),
          text: this.$t('unableToJoinAtThisMoment'),
          type: 'error',
          showConfirmButton: false,
          toast: true,
          position: 'top-end',
          timer: 3000
        });
      }
    },

    async continueJoinedEnrollment() {
      await this.getUserProfile();
      //used to get also the new project member's info
      this.showJoinedProjectDialog = false;
      this.$router.push({
        name: 'viewSelectedProject',
        params: {
          id: this.$route.params.id,
          lang: this.defaultLanguage
        },
        query: {
          directRegistration: true
        }
      });

      this.showDirectRegistrationDialog = true;
    },

    async continueDirectRegistrationEnrollment(payload) {
      this.loadingDirectRegistration = true;
      const { memberOf, suggestion } = payload;

      const memberOfId = this.userProfile.profile.enrollment
        .find(
          enrollment =>
            enrollment.type === 'DIRECT_REGISTRATION' &&
            enrollment.projectId.replace('#', '') === this.$route.params.id
        )
        .memberOfId.replace('#', '');

      const onlyOtherRole = !payload?.memberOf;
      this.onlyOtherRole = !payload?.memberOf;
      //If user selected a role
      if (memberOf)
        await this.selfRegistrationRoleSelected(memberOf, memberOfId);

      //If user selected other role option
      if (suggestion)
        await this.selfRegistrationOtherRoleSelected(
          suggestion,
          memberOfId,
          onlyOtherRole
        );

      this.loadingDirectRegistration = false;
      this.showDirectRegistrationDialog = false;
    },

    async selfRegistrationRoleSelected(memberOf, memberOfId) {
      const profileId = this.userProfile.profile.profileId.replace('#', '');
      const groupId = this.userProfile.profile.enrollment
        .find(
          enrollment =>
            enrollment.type === 'DIRECT_REGISTRATION' &&
            enrollment.projectId.replace('#', '') === this.$route.params.id
        )
        .projectGroupId.replace('#', '');

      //Update MemberOf using selected roles
      await memberOfAPI.updatePermission(memberOfId, { memberOf });

      // update enrollment to step 3
      await profileAPI.updateEnrollmentStep(profileId, groupId, 3);
      await this.getUserProfile();

      const nonSystemEnrollmentTemplates = this.userProfile.profile.enrollment[0].templateFormId.list.filter(
        templateId => templateId.replace('#', '') !== this.brand.systemTemplateId
      );

      if (nonSystemEnrollmentTemplates.length > 0) {
        return this.$router.push({
          name: 'createShowcase',
          query: {
            type: 'enroll'
          }
        });
      }

      await profileAPI.deleteMemberSteps(profileId, groupId);
      await this.getUserProfile();

      this.$router.push(
        `/view-projects/${this.$route.params.id}/${this.defaultLanguage}`
      );

      this.showBaseMsgDialogEnrollmentOtherRole = true;
    },

    async selfRegistrationOtherRoleSelected(
      suggestion,
      memberOfId,
      onlyOtherRole
    ) {
      const res = await memberOfAPI.newRoleRequest(memberOfId, { suggestion });
      if (onlyOtherRole) {
        await this.deleteEnrollment();
        this.$router.push(
          `/view-projects/${this.$route.params.id}/${this.defaultLanguage}`
        );
        this.showBaseMsgDialogEnrollmentOtherRole = true;
      }
      //Add Swal
      return res;
    },

    async deleteEnrollment() {
      const enrollL = this.userProfile.profile.enrollment.length;
      const currEnroll = this.userProfile.profile.enrollment[enrollL - 1];
      const profileId = this.userProfile.profile.profileId.replace('#', '');
      const groupId = currEnroll.projectGroupId.replace('#', '');
      await profileAPI.deleteMemberSteps(profileId, groupId);
      await this.getUserProfile();
    },

    async fetchPermissions() {
      if (!this.userProfile?.profile) return;
      const res = await permissionAPI.get();
      this.permissions = res.list;
    },

    async fetchProject() {
      try {
        if (this.$route.params.groupId) {
          const projectGroup = await projectGroupAPI.getById(
            this.$route.params.groupId
          );
          this.fullProject = projectGroup;
          this.projectMemberCount = this.fullProject?.project?.memberCount;

          return;
        }
        const project = await projectAPI.getById(this.$route.params.id);
        this.fullProject = project;
        this.defaultProjectGroupId = project?.defaultProjectGroup.projectGroupId.replace(
          '#',
          ''
        );

        this.projectMemberCount = this.fullProject?.project?.memberCount;

        return;
      } catch (e) {
        this.$router.push({ name: '404' });
      }
    },
    async fetchProjectRoles() {
      const projectRoles = await projectAPI.getRoles(this.$route.params.id);
      this.projectRoles = projectRoles.filter(
        ({ composedBy }) => composedBy.role !== 'SYSTEM'
      );
    },

    onTabChange(value, id) {
      const query = {
        section: this.tabs[value].toLowerCase()
      };

      if (id) query['itemId'] = id;
      this.$router.replace({
        path: '',
        query
      });
    },

    async getTabs() {
      this.tabsLoading = true;
      let tabCounters;
      let minGroupCount = 1;
      if (this.$route?.params?.groupId) {
        minGroupCount = 0;
        tabCounters = await projectGroupAPI.getTabCounters(
          this.$route.params.groupId
        );
      } else {
        tabCounters = await projectAPI.getTabCounters(this.$route.params.id);
      }

      const map = {
        guidelinesCounter: 'guidelines',
        memberCounter: 'members',
        documentCounter: 'showcases',
        creativityCounter: 'creativities',
        itineraryCounter: 'itineraries',
        groupCounter: 'groups'
      };

      this.tabs.push('home');
      for (const key in tabCounters) {
        if (this.currUserPermissions.length > 0) {
          this.tabs.push(map[key]);
        } else if (tabCounters[key] > minGroupCount && map[key] === 'groups') {
          this.tabs.push(map[key]);
        } else if (map[key] === 'guidelines') {
          if (!this.hideGuidelines) this.tabs.push(map[key]);
        } else if (tabCounters[key] > 0 && map[key] !== 'groups') {
          this.tabs.push(map[key]);
        }
      }
      if (
        (this.userProfile?.profile && this.userIsProjectMember) ||
        this.isAdmin
      ) {
        this.tabs.push('settings');
      }

      if (this.tabs.indexOf(this.$route.query.section) > -1) {
        this.activeTab = this.tabs.indexOf(this.$route.query.section);
        this.activeContainer = this.tabs.indexOf(this.$route.query.section);
      } else {
        this.activeTab = 0;
      }
      this.tabsLoading = false;
      return;
    },

    async getLatestMembersAndShowcases() {
      this.lastestItemsLoading = true;
      let members;
      let showcases;
      const commonLoad = { pageSize: 5, order: 'desc' };
      const { id } = this.$route.params;
      const memberLoad = {
        ...commonLoad,
        sort: 'memberOf.creationDate'
      };
      const showcaseLoad = {
        ...commonLoad,
        sort: 'document.lastUpdate'
      };

      if (this.$route.params.groupId) {
        const groupId = this.$route.params.groupId;
        members = await projectGroupAPI.getMembers(groupId, memberLoad);
        members.list = members.list.filter(
          member => member.profile.profileId !== this.projectLeaderProfileId
        );
        showcases = await projectGroupAPI.getDocuments(groupId, showcaseLoad);
      } else {
        members = await projectAPI.getMembers(id, memberLoad);
        showcases = await projectAPI.getDocuments(id, showcaseLoad);
      }

      this.latestMembers = members.list;
      this.latestShowcases = showcases.list;
      this.lastestItemsLoading = false;
    },

    async getMembers() {
      this.membersLoading = true;
      this.memberPayload.page = 1;
      const payload = {
        ...this.memberPayload,
        ...this.memberSort,
        filterMemberOf: [],
        filter: []
      };

      if (this.memberFilters.length > 0) {
        this.memberFilters.forEach(filter => {
          if (
            filter.property === 'roles.list' ||
            filter.property === 'names.list.values()'
          ) {
            const changeConditionFilter = { ...filter, condition: 'contains' };
            payload.filterMemberOf.push(changeConditionFilter);
          } else if (filter.property === 'contentFilter') {
            payload['contentFilter'] = filter.query;
          } else {
            payload.filter.push(filter);
          }
        });
      }

      let members = [];
      if (this.$route.params.groupId) {
        members = await projectGroupAPI.getMembers(
          this.$route.params.groupId,
          payload
        );
        members.list = members.list.filter(
          member => member.profile.profileId !== this.projectLeaderProfileId
        );
      } else {
        members = await projectAPI.getMembers(this.$route.params.id, payload);
      }

      this.members = members.list.map(a => ({
        ...a,
        isEdit: false,
        editKey: 0
      }));
      this.membersLoading = false;
      this.canLoadMoreMembers = members.hasNext;
    },

    async getMoreMembers() {
      this.memberPayload.page++;
      const payload = {
        ...this.memberPayload,
        ...this.memberSort,
        filterMemberOf: [],
        filter: []
      };
      if (this.memberFilters.length > 0) {
        this.memberFilters.forEach(filter => {
          if (
            filter.property === 'roles.list' ||
            filter.property === 'names.list.values()'
          ) {
            const changeConditionFilter = { ...filter, condition: 'contains' };
            payload.filterMemberOf.push(changeConditionFilter);
          } else if (filter.property === 'contentFilter') {
            payload['contentFilter'] = filter.query;
          } else {
            payload.filter.push(filter);
          }
        });
      }

      let members = [];
      if (this.$route.params.groupId) {
        members = await projectGroupAPI.getMembers(
          this.$route.params.groupId,
          payload
        );

        members.list = members.list.filter(
          member => member.profile.profileId !== this.projectLeaderProfileId
        );
      } else {
        members = await projectAPI.getMembers(this.$route.params.id, payload);
      }
      const listOfMembers = members.list.map(a => ({ ...a, isEdit: false }));
      this.members.push(...listOfMembers);
      this.canLoadMoreMembers = members.hasNext;
    },

    async getShowcases() {
      this.canLoadMoreShowcases = true;
      this.showcasesLoading = true;
      this.showcasePayload.page = 1;

      const payload = {
        ...this.showcasePayload,
        ...this.showcaseSort,
        filter: [
          {
            property: 'creativity',
            query: false,
            condition: 'eq'
          }
        ]
      };

      if (this.showcaseFilters.length > 0) {
        this.showcaseFilters.forEach(filter => {
          if (filter.property === 'contentFilter') {
            payload['contentFilter'] = filter.query;
          } else {
            payload.filter.push(filter);
          }
        });
      }

      let showcases = [];

      if (this.$route.params.groupId) {
        showcases = await projectGroupAPI.getDocuments(
          this.$route.params.groupId,
          payload
        );
      } else {
        showcases = await projectAPI.getDocuments(
          this.$route.params.id,
          payload
        );
      }
      this.showcases = showcases.list.filter(
        showcase => showcase.document.status !== 'REJECTED'
      );
      this.showcasesLoading = false;
      this.canLoadMoreShowcases = showcases.hasNext;
    },

    async getMoreShowcases() {
      this.showcasePayload.page++;
      const payload = {
        ...this.showcasePayload,
        ...this.showcaseSort,
        filter: [
          {
            property: 'creativity',
            query: false,
            condition: 'eq'
          }
        ]
      };

      if (this.showcaseFilters.length > 0) {
        this.showcaseFilters.forEach(filter => {
          if (filter.property === 'contentFilter') {
            payload['contentFilter'] = filter.query;
          } else {
            payload.filter.push(filter);
          }
        });
      }

      let showcases = [];

      if (this.$route.params.groupId) {
        showcases = await projectGroupAPI.getDocuments(
          this.$route.params.groupId,
          payload
        );
      } else {
        showcases = await projectAPI.getDocuments(
          this.$route.params.id,
          payload
        );
      }

      const filteredShowcases = showcases.list.filter(
        showcase => showcase.document.status !== 'REJECTED'
      );

      this.showcases.push(...filteredShowcases);
      this.canLoadMoreShowcases = showcases.hasNext;
    },

    async getCreativities() {
      this.creativityPayload.page = 1;
      const payload = {
        ...this.creativityPayload,
        ...this.creativitySort,
        filter: [
          {
            property: 'creativity',
            query: true,
            condition: 'eq'
          }
        ]
      };
      this.canLoadMoreCreativities = true;
      this.creativityLoading = true;

      if (this.creativityFilters.length > 0) {
        this.creativityFilters.forEach(filter => {
          if (filter.property === 'contentFilter') {
            payload['contentFilter'] = filter.query;
          } else {
            payload.filter.push(filter);
          }
        });
      }

      let showcases = [];

      if (this.$route.params.groupId) {
        showcases = await projectGroupAPI.getDocuments(
          this.$route.params.groupId,
          payload
        );
      } else {
        showcases = await projectAPI.getDocuments(
          this.$route.params.id,
          payload
        );
      }
      this.creativities = showcases.list.filter(
        showcase => showcase.document.status !== 'REJECTED'
      );
      this.creativityLoading = false;
      this.canLoadMoreCreativities = showcases.hasNext;
    },

    async getMoreCreativites() {
      this.creativityPayload.page++;
      const payload = {
        ...this.creativityPayload,
        ...this.creativitySort,
        filter: [
          {
            property: 'creativity',
            query: true,
            condition: 'eq'
          }
        ]
      };

      if (this.creativityFilters.length > 0) {
        this.creativityFilters.forEach(filter => {
          if (filter.property === 'contentFilter') {
            payload['contentFilter'] = filter.query;
          } else {
            payload.filter.push(filter);
          }
        });
      }

      let showcases = [];

      if (this.$route.params.groupId) {
        showcases = await projectGroupAPI.getDocuments(
          this.$route.params.groupId,
          payload
        );
      } else {
        showcases = await projectAPI.getDocuments(
          this.$route.params.id,
          payload
        );
      }

      const filteredShowcases = showcases.list.filter(
        showcase => showcase.document.status !== 'REJECTED'
      );
      this.creativities.push(...filteredShowcases);
      this.canLoadMoreCreativities = showcases.hasNext;
    },

    async getGroups() {
      this.groupsLoading = true;
      this.canLoadMoreGroups = true;
      this.groupsPayload.page = 1;
      const payload = {
        ...this.groupsPayload,
        ...this.groupsSort,
        filter: [],
        filterLeader: []
      };

      if (this.groupsFilters.length > 0) {
        this.groupsFilters.forEach(filter => {
          if (filter.property === 'nameGroupLeader') {
            const correctFilter = {
              property: 'name',
              query: filter.query
            };
            payload.filterLeader.push(correctFilter);
          } else if (filter.property === 'contentFilter') {
            payload['contentFilter'] = filter.query;
          } else {
            payload.filter.push(filter);
          }
        });
      }

      let groups = [];
      if (this.$route.params.groupId) {
        groups = await projectGroupAPI.getGroups(
          this.$route.params.groupId,
          payload
        );
      } else {
        groups = await projectAPI.getGroups(this.$route.params.id, payload);
      }
      this.projectGroups = groups.list.filter(
        a => a.projectGroup.name !== 'DEFAULT'
      );
      this.groupsLoading = false;
      this.canLoadMoreGroups = groups.hasNext;
    },

    async getMoreGroups() {
      this.groupsPayload.page++;
      const payload = {
        ...this.groupsPayload,
        ...this.groupsSort,
        filter: [],
        filterLeader: []
      };

      if (this.groupsFilters.length > 0) {
        this.groupsFilters.forEach(filter => {
          if (filter.property === 'nameGroupLeader') {
            const correctFilter = {
              property: 'name',
              query: filter.query
            };
            payload.filterLeader.push(correctFilter);
          } else if (filter.property === 'contentFilter') {
            payload['contentFilter'] = filter.query;
          } else {
            payload.filter.push(filter);
          }
        });
      }

      let groups = [];
      if (this.$route.params.groupId) {
        groups = await projectGroupAPI.getGroups(
          this.$route.params.groupId,
          payload
        );
      } else {
        groups = await projectAPI.getGroups(this.$route.params.id, payload);
      }

      const filteredProjects = groups.list.filter(
        a => a.projectGroup.name !== 'DEFAULT'
      );

      this.projectGroups.push(...filteredProjects);
      this.canLoadMoreGroups = groups.hasNext;
    },

    async getItineraries() {
      this.itinerariesLoading = true;
      this.canLoadMoreItineraries = true;
      this.itineraryPayload.page = 1;
      const payload = {
        ...this.itineraryPayload,
        ...this.itinerarySort,
        filter: []
      };

      if (this.itineraryFilters.length > 0) {
        this.itineraryFilters.forEach(filter => {
          if (filter.property === 'contentFilter') {
            payload['contentFilter'] = filter.query;
          } else {
            payload.filter.push(filter);
          }
        });
      }

      if (this.$route?.params?.groupId) {
        const projectGroupFilter = {
          property: 'projectGroupId',
          query: this.$route.params.groupId,
          condition: 'eq'
        };
        payload.filter.push(projectGroupFilter);
      }

      const itineraries = await projectAPI.getItineraries(
        this.$route.params.id,
        payload
      );

      this.canLoadMoreItineraries = itineraries.hasNext;
      this.itinerariesLoading = false;
      this.itineraries = itineraries.list;
    },

    async getMoreItineraries() {
      this.itineraryPayload.page++;
      const payload = {
        ...this.itineraryPayload,
        ...this.itinerarySort,
        filter: []
      };

      if (this.itineraryFilters.length > 0) {
        this.itineraryFilters.forEach(filter => {
          if (filter.property === 'contentFilter') {
            payload['contentFilter'] = filter.query;
          } else {
            payload.filter.push(filter);
          }
        });
      }

      const itineraries = await projectAPI.getItineraries(
        this.$route.params.id,
        payload
      );

      this.canLoadMoreItineraries = itineraries.hasNext;

      this.itineraries.push(...itineraries.list);
    },

    async getUserPermissions() {
      try {
        const userId = this.userProfile?.profile?.profileId?.replace('#', '');
        if (!userId) return;
        const project = await profileAPI.getProjects(userId, {
          filter: {
            property: '@rid',
            query: this.$route.params.id,
            condition: 'eq'
          },
          page: 1,
          pageSize: 1,
          language: this.defaultLanguage
        });
        this.userIsProjectMember = project.list.length > 0;

        const projectLeaderProfileId = project?.list?.[0]?.projectLeaderProfile?.profileId?.replace(
          '#',
          ''
        );
        const projectFounderProfileId = project?.list?.[0]?.projectFounder?.profileId?.replace(
          '#',
          ''
        );

        if (
          projectLeaderProfileId === userId ||
          projectFounderProfileId === userId ||
          this.isAdmin
        ) {
          //Setting property to true also for admin to give admin the same functionality
          this.userIsProjectLeader = true;

          this.currUserPermissions = [
            'PROJECT_VIEW',
            'PROJECT_EDIT',
            'PROJECT_GROUP_VIEW',
            'PROJECT_GROUP_EDIT',
            'PROJECT_GROUP_CREATE',
            'PROJECT_GROUP_INVITE',
            'DOCUMENT_SUBMIT',
            'DOCUMENT_ACTION',
            'DOCUMENT_REVIEW',
            'DOCUMENT_PREPUBLISH',
            'DOCUMENT_PUBLISH',
            'CAN_HANDLE_CREATIVITY',
            'PROFILE_IMPERSONATE'
          ];
        } else {
          this.currUserPermissions =
            project?.list?.[0]?.memberOfs[0].memberOf.permissions || [];

          const userRoles = project?.list?.[0]?.memberOfs[0]?.memberOf?.roles;
          if (userRoles && userRoles.includes('PROJECT_LEADER'))
            this.userIsProjectLeader = true;
        }

        if (
          this.$route?.params?.groupId &&
          !this.userIsProjectLeader &&
          this.userIsProjectMember
        ) {
          const memberOf = project.list[0].memberOfs.find(
            memberOf =>
              memberOf.projectGroup.projectGroupId ===
              `#${this.$route?.params?.groupId}`
          );

          if (!memberOf) return;
          this.currUserPermissions = memberOf.memberOf.permissions;
          this.userIsGroupLeader = memberOf.memberOf.roles.includes(
            'GROUP_LEADER'
          );
        }
      } catch (e) {
        console.log(e);
      }

      if (this.currUserPermissions.includes('PROJECT_GROUP_INVITE'))
        this.getProfileGroupsForInvite();
    },

    deleteMemberErrorPopup() {
      Swal.fire({
        title: this.$t('error'),
        text: this.$t('deleteMemberError'),
        type: 'error',
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        timer: 3000
      });
    },

    deleteMemberSuccessPopup() {
      Swal.fire({
        title: this.$t('success'),
        text: this.$t('deletedMembers'),
        type: 'success',
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        timer: 3000
      });
    },

    routeToSection(str) {
      let currentTab = this.tabs.findIndex(tab => {
        return tab.toLowerCase() === str.toLowerCase();
      });

      if (str === 'showcases' && currentTab < 0) {
        currentTab = this.tabs.findIndex(tab => {
          return tab.toLowerCase() === 'creativities';
        });
      }

      this.onTabChange(currentTab);
      this.activeTab = currentTab;
    },

    viewLatestItem(object) {
      const { type, id } = object;

      const currentTab = this.tabs.findIndex(tab => {
        return tab.toLowerCase() === type.toLowerCase();
      });

      this.onTabChange(currentTab, id);
      this.activeTab = currentTab;
    },

    async getProfileGroupsForInvite() {
      if (!this.userProfile?.profile) return;
      const profileId = this.userProfile.profile.profileId.replace('#', '');

      const payload = {
        pageSize: 300,
        projectFilter: {
          property: '@rid',
          query: this.$route.params.id,
          condition: 'eq'
        }
      };

      try {
        const res = await profileAPI.getProjectGroups(profileId, payload);
        this.profileGroupsForInvite = res.list.filter(
          group => group.projectGroup.name !== 'DEFAULT'
        );

        const defaultGroup = res.list.find(
          group => group.projectGroup.name === 'DEFAULT'
        );

        this.profileDefaultGroup = defaultGroup;
      } catch (e) {
        console.log(e);
      }
    },
    reassignmentFromGroupHandler(id) {
      this.members = this.members.filter(
        member => member.profile.profileId !== id
      );
    },

    rehydrateGLHandler(value) {
      if (this.projectGroups.length === 0) return;
      const { profileIndex, projectGroupId } = value;
      const newGroupLeader = this.members[profileIndex].profile;
      const groupIndex = this.projectGroups.findIndex(
        projectGroup =>
          projectGroup.projectGroup.projectGroupId === projectGroupId
      );

      this.projectGroups[groupIndex].projectGroupLeaderProfile = newGroupLeader;
    },

    async getDefaultRoles() {
      try {
        const res = await rolesApi.get();

        this.defaultRoles = res.list;
      } catch (e) {}
    },

    hanldeActiveSection(index) {
      const previousActiveTab = this.activeTab;

      this.onTabChange(index);
      if (index === this.activeTab) return (this.activeTab = null);

      this.activeTab = index;

      //this is to wait for the section to close in order to
      //change class to container2
      if (previousActiveTab === 0) {
        setTimeout(() => {
          this.activeContainer = index;
        }, 500);

        return;
      }

      this.activeContainer = index;
    },

    handleFilter(value, filterType) {
      const hasSameFilterValue = this.checkIfFilterExist(
        value,
        this[filterType]
      );

      const { property, query } = value;

      let newFilterToPush = value;

      const filtersWithStatus = {
        itineraryFilters: {
          addFalseArchiveFilter: false,
          hasArchivedFilter: false,
          hasStatusFilter: false
        },
        showcaseFilters: {
          addFalseArchiveFilter: false,
          hasArchivedFilter: false,
          hasStatusFilter: false
        },
        creativityFilters: {
          addFalseArchiveFilter: false,
          hasArchivedFilter: false,
          hasStatusFilter: false
        }
      };

      this[filterType].forEach(filter => {
        if (filter.property === 'archived' && query === true)
          filtersWithStatus[filterType].hasArchivedFilter = true;
        if (filter.property === 'status')
          filtersWithStatus[filterType].hasStatusFilter = true;
      });

      if (property === 'status') {
        const archiveFilter = this[filterType].find(
          filter => filter.property === 'archived'
        );

        if (filtersWithStatus[filterType].hasArchivedFilter) {
          //change archived filter to false to only get status filter
          archiveFilter.query = false;
        } else if (query === 'ARCHIVED') {
          if (!filtersWithStatus[filterType].hasArchivedFilter) {
            newFilterToPush = { property: 'archived', query: true };
          } else {
            archiveFilter.query = true;
          }

          if (filtersWithStatus[filterType].hasStatusFilter) {
            this[filterType] = this[filterType].filter(
              filter => filter.property !== 'status'
            );
          }
        } else {
          if (!archiveFilter) {
            filtersWithStatus[filterType].addFalseArchiveFilter = true;
          } else {
            archiveFilter.query = false;
          }
        }
      }

      if (!hasSameFilterValue) {
        this[filterType].push(newFilterToPush);
      } else {
        const filteredFilters = this[filterType].filter(
          filter => filter.property !== newFilterToPush.property
        );
        this[filterType] = [...filteredFilters, newFilterToPush];
      }

      if (filtersWithStatus[filterType]?.addFalseArchiveFilter) {
        this[filterType].push({ property: 'archived', query: false });
      }

      if (filterType === 'memberFilters') {
        this.getMemberOfNames(this.$route.params.id, this.memberFilters);
      }

      if (filterType === 'itineraryFilters') {
        this.getItineraryAdditionalFilters();
      }

      const sectionsToResetFilterList = [
        'showcaseFilters',
        'creativityFilters'
      ];
      if (sectionsToResetFilterList.includes(filterType)) {
        let type = filterType === 'showcaseFilters' ? 'document' : 'creativity';

        this.getSectionAdditionalFilters(type);
      }
    },

    removeFilter(value, filterType) {
      if (value === 'all-additonal') {
        this[filterType] = this[filterType].filter(
          filter => filter.property === 'contentFilter'
        );
      } else {
        this[filterType] = this[filterType].filter(
          filter => filter.property !== value.property
        );
      }

      if (filterType === 'memberFilters') {
        this.getMemberOfNames(this.$route.params.id, this.memberFilters);
      }

      if (filterType === 'itineraryFilters') {
        this.getItineraryAdditionalFilters();
      }

      const sectionsToResetFilterList = [
        'showcaseFilters',
        'creativityFilters'
      ];
      if (sectionsToResetFilterList.includes(filterType)) {
        let type = filterType === 'showcaseFilters' ? 'document' : 'creativity';

        this.getSectionAdditionalFilters(type);
      }
    },

    //when click on brand logo
    handleHomeClick() {
      if (this.userProfile.hasOwnProperty('profile'))
        this.$router.push('/dashboard');
      else this.$router.push('/home');
    },

    //when click on back arrorw
    handlePreviousClick() {
      // handling group project back to project
      if (this.$route?.params?.groupId) {
        if (!this.previousRoute?.from?.name) {
          return this.$router.push(
            `/view-projects/${this.$route.params.id}/${this.defaultLanguage}`
          );
        }

        return this.$router.push(this.previousRoute.from.fullPath);
      }

      if (
        this.hasParentProject &&
        this.previousRoute?.from?.name === 'browseProjects'
      ) {
        const parentProjectName = this.findTranslation(
          this.fullProject?.parentProject?.name,
          this.defaultLanguage
        );

        return this.$router.push(
          `/view-parent-project/${this.fullProject.parentProject.parentProjectId.replace(
            '#',
            ''
          )}/${this.defaultLanguage}?parentProject=${parentProjectName}`
        );
      }

      if (
        this.previousRoute?.from?.name === 'viewProjects' ||
        this.previousRoute?.from?.name === 'browseParentAndProjects'
      ) {
        return this.$router.push(this.previousRoute.from.fullPath);
      }

      if (this.userProfile.hasOwnProperty('profile'))
        this.$router.push('/dashboard');
      else this.$router.push('/home');
    },

    async bookmarkItineraryHandler(itineraryInfo) {
      try {
        const { itineraryId, action } = itineraryInfo;
        if (action === 'bookmarkItinerary') {
          await itinerariesAPI.bookmark(itineraryId, { pinned: true });
        } else {
          await itinerariesAPI.unbookmark(itineraryId);
        }

        const indexOfItinerary = this.itineraries.findIndex(itinerary => {
          return itinerary.itinerary.itineraryId === `#${itineraryId}`;
        });

        let pinnedStatus = false;
        if (action === 'bookmarkItinerary') pinnedStatus = true;
        this.itineraries[indexOfItinerary].itinerary.pinned = pinnedStatus;
        this.itineraries[indexOfItinerary].itinerary.bookmark = pinnedStatus;

        Swal.fire({
          title: this.$t('success'),
          text: `${this.$t('youHaveSuccesfully')} ${
            action === 'bookmarkItinerary'
              ? this.$t('pinned')
              : this.$t('unpinned')
          } ${this.$t('itinerary')}`,
          type: 'success',
          showConfirmButton: false,
          toast: true,
          position: 'top-end',
          timer: 3000
        });
      } catch (e) {
        Swal.fire({
          title: this.$t('error'),
          text: `${this.$t('unableTo')} ${
            action === 'bookmarkItinerary' ? this.$t('pin') : this.$t('unpin')
          }  ${this.$t('itinerary')}`,
          type: 'error',
          showConfirmButton: false,
          toast: true,
          position: 'top-end',
          timer: 3000
        });
      }
    },

    async deleteItinerary(id) {
      Swal.fire({
        title: this.$t('areYouSure'),
        text: this.$t('revertMessage'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.$vuetify.theme.themes.light.brand,
        cancelButtonColor: '',
        confirmButtonText: this.$t('yesDeleteIt')
      }).then(async result => {
        if (result.value) {
          const itineraryId = id.replace('#', '');

          const res = await itinerariesAPI.delete(itineraryId);
          this.getUserProfile();
          if (res.success) {
            Swal.fire({
              title: this.$t('success'),
              text: this.$t('deletedItinerary'),
              type: 'success',
              showConfirmButton: false,
              toast: true,
              position: 'top-end',
              timer: 3000
            });

            this.itineraries = this.itineraries.filter(
              item => item.itinerary.itineraryId !== id
            );
          } else {
            Swal.fire({
              title: this.$t('error'),
              text: this.$t('deletedItineraryError'),
              type: 'error',
              showConfirmButton: false,
              toast: true,
              position: 'top-end',
              timer: 3000
            });
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          return null;
        }
      });
    },

    checkProjectSubscriptionMax() {
      const { subscribedTo, subscription } = this.userProfile;
      const { name, maxProjects } = subscription;
      const { projectCount } = subscribedTo;

      const maxProjectsNum =
        name.toLowerCase() === 'unlimited' ? Infinity : Number(maxProjects);

      if (projectCount >= maxProjectsNum) {
        this.reachedMaxInformation = {
          name,
          maxEntity: maxProjects,
          entityCount: projectCount,
          entity: 'projects'
        };
        this.showReachedMax = true;
      }
    },

    checkProjectMembersSubscriptionMax() {
      const { name, maxMembersPerProject } = this.userProfile.subscription;
      this.projectMemberCount++;
      const maxProjectsNum = Number(maxMembersPerProject);

      if (this.projectMemberCount === maxProjectsNum) {
        this.reachedMaxInformation = {
          name,
          maxEntity: maxMembersPerProject,
          entityCount: this.fullProject.project.memberCount,
          entity: 'members'
        };
        this.showReachedMax = true;
      }
    },

    closeBaseReachedMaxHandler() {
      this.showReachedMax = false;
      this.reachedMaxInformation = {};
      this.maxDialogKey++;

      if (!this.$route?.query?.section) this.$router.replace({ query: null });
    },

    showPricingDialogHandler(value) {
      if (value && value === 'invite')
        this.showInviteMessagePricingDialog = true;
      this.showPricingDialog = true;
    },

    getSectionAdditionalFilters(entity) {
      const filterTypes = {
        document: this.showcaseFilters,
        creativity: this.creativityFilters
      };

      this.getKindValues(
        'project',
        filterTypes[entity],
        entity,
        this.$route.params.id
      );

      if (this.userProfile?.profile) {
        let filters;

        if (entity === 'document') {
          filters = [
            ...this.showcaseFilters,
            {
              property: 'creativity',
              query: false,
              condition: 'eq'
            }
          ];
        } else {
          filters = [
            ...this.creativityFilters,
            {
              property: 'creativity',
              query: true,
              condition: 'eq'
            }
          ];
        }

        this.getDocumentStatusCount(
          'project',
          filters,
          this.$route.params.id,
          entity
        );
      }
    },

    async getItineraryAdditionalFilters() {
      if (!this.userProfile?.profile || !this.userIsProjectMember) return;
      try {
        const payload = {
          filter: []
        };

        if (this.itineraryFilters.length > 0) {
          this.itineraryFilters.forEach(filter => {
            if (filter.property === 'contentFilter') {
              payload['contentFilter'] = filter.query;
            } else {
              payload.filter.push(filter);
            }
          });
        }

        const res = await projectAPI.getItineraryStatusCount(
          this.$route.params.id,
          payload
        );

        const availableStatus = {
          CREATED: 'drafts',
          PUBLISHED: 'published'
        };

        const statusCount = {
          PUBLISHED: 0,
          CREATED: 0
        };

        const statusHaveArchived = status =>
          status.hasOwnProperty('archived') && status.archived > 0;

        const hasArchived = res.some(statusHaveArchived);

        if (hasArchived) {
          availableStatus['ARCHIVED'] = 'archivedUpperCase';
          statusCount['ARCHIVED'] = 0;
        }

        res.forEach(status => {
          statusCount[status.status] = status?.notArchived
            ? status.notArchived
            : 0;

          if (hasArchived && status.hasOwnProperty('archived')) {
            statusCount.ARCHIVED = statusCount.ARCHIVED + status.archived;
          }
        });

        const statusKeys = Object.keys(availableStatus);

        const mappedStatus = statusKeys.map(key => {
          return {
            text: this.$t(availableStatus[key]),
            count: statusCount[key],
            value: key
          };
        });

        this.itinerariesStatusList = mappedStatus;
      } catch (e) {
        console.log(e);
      }
    },

    getMemberOfNamesForDialog(filters) {
      this.getMemberOfNames(this.$route.params.id, filters);
    },

    async updateItineraryStatus(item) {
      try {
        const itineraryId = item.itineraryId.replace('#', '');

        const updatePayload = {
          status: item.status
        };

        await itinerariesAPI.updateStatus(itineraryId, updatePayload);

        const foundItinerary = this.itineraries.find(
          itinerary => itinerary.itinerary.itineraryId === item.itineraryId
        );

        foundItinerary.itinerary.status = item.status;

        const statusText =
          item.status === 'PUBLISHED'
            ? this.$t('published').toLowerCase()
            : this.$t('unpublished').toLowerCase();

        const message = `${this.$t(
          'youHaveSuccesfully'
        )} ${statusText} ${this.$t('itinerary').toLowerCase()}`;

        Swal.fire({
          title: this.$t('success'),
          text: message,
          type: 'success',
          showConfirmButton: false,
          toast: true,
          position: 'top-end',
          timer: 3000
        });
      } catch (e) {
        console.log(e);
        const statusText =
          item.status === 'PUBLISHED'
            ? this.$t('publish').toLowerCase()
            : this.$t('unpublish').toLowerCase();

        const message = `${this.$t('unableTo')} ${statusText} ${this.$t(
          'itinerary'
        ).toLowerCase()} ${this.$t('pleaseTryAgain')}`;

        Swal.fire({
          title: this.$t('error'),
          text: message,
          type: 'error',
          showConfirmButton: false,
          toast: true,
          position: 'top-end',
          timer: 3000
        });
      }
    },

    async fetchUnfilteredKinds() {
      try {
        const res = await documentAPI.kindValues({
          projectId: this.$route.params.id
        });

        this.kindsUnfiltered = res.list;
      } catch (e) {
        console.log(e);
      }
    },

    async fetchUnfilteredTags() {
      try {
        const res = await projectAPI.getMemberOfNames(this.$route.params.id);

        this.tagsUnfiltered = res.list;
      } catch (e) {
        console.log(e);
      }
    },

    stripHtml(html) {
      const tmp = document.createElement('DIV');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    }
  },

  computed: {
    ...mapState({
      userProfile: state => state.authentication.userProfile,
      brand: state => state.brand.brand,
      defaultLanguage: state => state.defaultLanguage
    }),

    hasLabelsFeature() {
      if (!this.brand?.hasLabelFeature) return false;

      return this.brand.hasLabelFeature;
    },

    logoSize() {
      if (!this.brand?.logoSize) return { height: '50', width: '50' };

      return this.brand.logoSize;
    },

    icons: () => ({
      mdiChevronUp,
      mdiChevronDown,
      mdiArrowLeft
    }),

    isAdmin() {
      if (!this.userProfile?.profile?.role) return false;
      const { role } = this.userProfile.profile;

      return role.toLowerCase() === 'admin';
    },

    tabsFixedStyle() {
      return 'position: sticky; top: 0px; background: white; z-index: 1; width: 100%;';
    },

    //Added this property to manipulate the new project structure and not have to change all of
    //the logic for read only items
    project() {
      if (!this.fullProject?.project) return {};

      const { project, ...theRest } = this.fullProject;
      const { template, ...restOfProject } = project;
      const templateItems = {};
      const templateKeys = Object.keys(template[0]);

      templateKeys.forEach(item => {
        templateItems[item] = this.findTranslationMultipleOptions(
          template[0][item],
          project.defaultLanguage,
          this.defaultLanguage
        );
      });

      return { ...theRest, project: { ...restOfProject, ...templateItems } };
    },

    description() {
      if (this.$route.params.groupId) {
        return this.project.projectGroup.description;
      }

      return this.project.project.description;
    },

    projectLogo() {
      return this.project?.project?.logo;
    },

    projectName() {
      return this.project?.project?.name;
    },

    projectColors() {
      return this.project?.project?.colors;
    },

    projectGuidelines() {
      if (this.$route.params.groupId) {
        return this.project.projectGroup.guidelines;
      }
      return this.project?.project?.guidelines;
    },

    directRegistrationRoles() {
      return this.projectRoles.filter(role => role.composedBy.visible);
    },

    hasParentProject() {
      return this.fullProject?.parentProject &&
        this.fullProject?.parentProject?.parentProjectId
        ? true
        : false;
    },

    parentProject() {
      return this.fullProject?.parentProject &&
        this.fullProject?.parentProject?.parentProjectId
        ? this.fullProject?.parentProject
        : {};
    },

    hideGuidelines() {
      if (!this.projectGuidelines) return true;

      const body = this.projectGuidelines.match(/<body[^>]*>[\s\S]*<\/body>/gi);
      if (!body) return false;
      if (
        body[0] === '<body><p><br /></p></body>' ||
        body[0] === '<body>null</body>' ||
        body[0] === '<body></body>'
      )
        return true;

      return false;
    },

    containerMaxWidth() {
      return `${window.innerWidth}px`;
    },

    projectLeaderProfileId() {
      return this.project.projectLeaderProfile.profileId;
    },

    projectFounderProfileId() {
      return this.project?.projectFounder?.profileId;
    },

    projectSubscriptionInfo() {
      const { project, projectFounder } = this.project;
      const { memberCount } = project;
      const { maxMembersPerProject } = projectFounder;
      const maxMembersPerProjectNum = Number(maxMembersPerProject);

      const info = {
        text: `<span><strong>${this.projectName}</strong> <br/> ${this.$t(
          'membersInProject'
        )}: ${memberCount}/${maxMembersPerProjectNum}</span>`,
        class: 'brand lighten-2 brand--text text--darken-1',
        hasReachedMaxCapacity: false
      };

      if (memberCount >= maxMembersPerProjectNum) {
        info.class = 'error lighten-2 error--text text--darken-1';
        info.hasReachedMaxCapacity = true;
      }

      return info;
    },

    maxedOutProjectMembers() {
      if (
        !this.project?.project ||
        !this.project?.projectFounder ||
        this.projectMemberCount === null
      )
        return false;

      const {
        maxMembersPerProject,
        isCloudStorageFull
      } = this.project?.projectFounder;

      if (maxMembersPerProject.toLowerCase() === 'unlimited') return false;

      const maxMembersPerProjectNum = Number(maxMembersPerProject);

      return (
        this.projectMemberCount >= maxMembersPerProjectNum || isCloudStorageFull
      );
    },

    isArchived() {
      return this.project?.project?.archived;
    },

    canArchiveContent() {
      return this.brand.canArchiveContent;
    },

    colors() {
      return [
        '#57AE5B',
        '#0000FF',
        '#800000',
        '#800080',
        '#008080',
        '#FF0000',
        '#1E90FF',
        '#000080',
        '#8B008B',
        '#A9A9A9',
        '#B22222',
        '#FF4500',
        '#228B22',
        '#2E8B57',
        '#C71585',
        '#8B4513',
        '#708090',
        '#000080'
      ];
    }
  },

  watch: {
    ['$route.params']: {
      deep: true,
      handler(newVal, oldVal) {
        const sameProjectIds = newVal?.id === oldVal?.id;
        const newRouteHasGroupId = newVal?.groupId ? true : false;
        const oldRouteHasGroupId = oldVal?.groupId ? true : false;
        const sameGroupIds = newRouteHasGroupId
          ? newVal?.groupId === oldVal?.groupId
          : false;

        //if no old project id
        if (!oldVal?.id) return;

        //if same project with no group
        if (sameProjectIds && !newRouteHasGroupId && !oldRouteHasGroupId)
          return;

        //if same project and same group
        if (sameProjectIds && sameGroupIds) return;

        this.init();
        this.fetchProjectRoles();
        this.getUserPermissions();
        this.fetchPermissions();
        const hasEnrollment = this.userProfile?.profile?.enrollment;
        if (this.$route?.query?.directRegistration && hasEnrollment) {
          this.showDirectRegistrationDialog = true;
        }
        this.tabs = [];
        this.forceUpdate++;
      }
    },

    ['$route.query.section'](newVal) {
      let section = newVal ? newVal : 'home';
      const currentTab = this.tabs.findIndex(tab => {
        return tab.toLowerCase() === section.toLowerCase();
      });

      this.activeTab = currentTab;
      this.activeContainer = currentTab;
    },

    defaultLanguage(newVal) {
      const { id, lang } = this.$route.params;
      this.$router.replace({
        name: '',
        params: {
          id,
          lang: newVal
        },
        query: {
          ...this.$route.query
        }
      });
    }
  },

  beforeRouteEnter: (to, from, next) => {
    next(async vm => {
      if (from.name) {
        vm.previousRoute = { from };
      }
    });
  }
};
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr;
}

.container2 {
  width: 80%;
  margin: auto;
}

.container2-hide-overflow {
  overflow: hidden;
}

.slide-fade-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}

.xs-tab {
  padding: 8px;
  margin: 8px 0px;
  background-color: #f6f8fa;
  border-radius: 5px;
}

.xs-tab-active {
  padding: 8px;
  margin: 8px 0px;
  background-color: #fff;
  border-radius: 5px;
  border: solid 1px var(--v-brand-base);
}
</style>
